import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=6f9de2f4"
var script = {}
import style0 from "./Credits.vue?vue&type=style&index=0&id=6f9de2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports